import { jsxs as r, jsx as t } from "react/jsx-runtime";
import { InputVariant as i } from "./InputVariant.type.mjs";
const G = (b) => {
  const {
    name: g,
    type: E,
    id: n,
    placeholder: x,
    reference: F,
    error: L,
    label: o,
    message: p,
    maxLength: M,
    testId: e,
    variant: a,
    helpText: u,
    reversed: y,
    disabled: B,
    iconPosition: I,
    icon: C,
    fixedEmailSuffix: $ = "@ampf.com",
    describedById: T,
    groupClassName: _,
    inputClassName: j,
    inputMode: w,
    pattern: A,
    minWidth: m
  } = b, l = a === i.FLOATING_LABEL, h = a === i.WITH_ICON || typeof I < "u", H = I || "right", v = a === i.NUMERIC, f = !!L, d = f && !!p, c = !!u, N = T || (n ? `${n}-error-help` : void 0), P = d || c, D = [
    "Input",
    l ? "Input--floatingLabel" : "",
    a === i.FIXED_EMAIL ? "Input--fixedEmail" : "",
    h ? "Input--withIcon" : "",
    h && H === "left" ? "Input--withIconLeft" : "",
    f ? "Input--error" : "",
    y ? "Input--reversed" : "",
    j || ""
  ].filter(Boolean).join(" "), s = /* @__PURE__ */ t(
    "input",
    {
      className: D,
      name: g,
      id: n,
      placeholder: x,
      type: E || "text",
      ref: F,
      maxLength: M,
      disabled: B,
      "aria-describedby": P ? N : void 0,
      inputMode: v ? "numeric" : w,
      pattern: v ? "[0-9]*" : A,
      style: m ? { minWidth: m } : void 0,
      "data-testid": e ? `${e}-input` : void 0,
      "data-qa": "Input-" + n
    }
  ), O = () => !d && !c ? null : /* @__PURE__ */ r("ul", { id: N, children: [
    d && /* @__PURE__ */ r(
      "li",
      {
        className: "Form-help Form-help--error",
        "data-qa": "InputError-" + n,
        "data-testid": e ? `${e}-message` : void 0,
        children: [
          /* @__PURE__ */ t(
            "span",
            {
              "data-testid": e ? `${e}-warning` : void 0,
              "aria-hidden": "true",
              children: "warning"
            }
          ),
          /* @__PURE__ */ t("span", { className: "u-hiddenVisually", children: "Error," }),
          /* @__PURE__ */ t("span", { children: p })
        ]
      }
    ),
    c && /* @__PURE__ */ t("li", { className: "Form-help", children: u })
  ] });
  return /* @__PURE__ */ r(
    "div",
    {
      className: ["Form-group", _ || ""].filter(Boolean).join(" "),
      children: [
        !l && o && /* @__PURE__ */ t(
          "label",
          {
            className: "Form-label",
            htmlFor: n,
            "data-testid": e ? `${e}-label` : void 0,
            children: o
          }
        ),
        l ? /* @__PURE__ */ r("div", { className: "Input-group", children: [
          s,
          /* @__PURE__ */ t(
            "label",
            {
              className: "Input-label",
              htmlFor: n,
              "data-testid": e ? `${e}-label` : void 0,
              children: o
            }
          )
        ] }) : a === i.WITH_ICON ? /* @__PURE__ */ r("div", { className: "Input-group", children: [
          s,
          /* @__PURE__ */ t("span", { className: "Input-icon", "aria-hidden": "true", children: C || "" })
        ] }) : a === i.FIXED_EMAIL ? /* @__PURE__ */ r("div", { className: "Input-group--flex", children: [
          s,
          /* @__PURE__ */ t("p", { className: "Input-email", children: $ })
        ] }) : s,
        O()
      ]
    }
  );
};
export {
  G as Input
};
//# sourceMappingURL=Input.mjs.map
